var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal select-assignment-modal",
      attrs: {
        id: "select-assignment-modal",
        title: _vm.$t("reports.select_assignments"),
        "ok-title": _vm.$t("common.confirm"),
        "close-title": _vm.$t("common.cancel"),
        "ok-disabled": _vm.okDisabled
      },
      on: {
        ok: function($event) {
          return _vm.applySelectedList()
        },
        cancel: function($event) {
          return _vm.$emit("cancel")
        }
      }
    },
    [
      _c("div", { staticClass: "select-assignment-modal__body" }, [
        _c(
          "div",
          {
            staticClass:
              "select-assignment-modal__checkbox-row select-assignment-modal__select-all-row"
          },
          [
            _c(
              "Checkbox",
              {
                attrs: { "model-value": _vm.isAll, "check-value": true },
                on: { change: _vm.selectAllAssignments }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "ml-3 typography--body-3",
                    attrs: { slot: "label" },
                    slot: "label"
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("reports.select_all_assignments")) +
                        "\n        "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "float-right typography--caption typography--color-secondary mt-1"
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("reports.select_all_assignments_help")) +
                    "\n      "
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          _vm._l(_vm.assignmentList, function(assignment) {
            return _c(
              "div",
              {
                key: assignment.id,
                staticClass: "select-assignment-modal__checkbox-row"
              },
              [
                _c(
                  "Checkbox",
                  {
                    attrs: {
                      "model-value": _vm.selectedList,
                      "check-value": assignment.id,
                      disabled: _vm.isAll
                    },
                    on: { change: _vm.selectAssignment }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "ml-3 typography--body-3",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(assignment.assigned_card.title) +
                            "\n          "
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            )
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96f47d8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96f47d8a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/classes/components/SelectAssignmentModal.vue
// module id = AVVC
// module chunks = 1